import { Tip } from 'shared/components/ui/Typography'

export default function PendingValidation({ children, ...rest }) {
  return <Tip {...rest}>{children || 'Validation pending...'}</Tip>
}
